<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window invite-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper dialog-content">
                <div class="dialog-body">
                    <div class="dialog-title t-invite"></div>
                    <div class="invite-view">
                        <div class="share-text msg-view">
                            <div class="text-content">
                                {{ shareTxt }}
                            </div>
                        </div>

                        <div class="u-btn copy" @click="copy" data-clipboard-action="copy" :data-clipboard-text="shareTxt"></div>
                    </div>

                </div>

            </div>         
        </div>
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            error_text : '请稍后再试', 
            error : false,
            shareTxt : '',                  
        }
    },
    created (){   
        document.body.style.overflow = 'hidden';
    },  
    methods : {
        destroyElement () {
            this.$destroy()
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              clipboard.destroy();
              _this.$toast("复制成功");
              _this.destroyElement();
            });
            clipboard.on('error', function () {
              clipboard.destroy()
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },             
    },
}
</script>

<style lang="scss" scoped>
.invite-view{
    padding: 30px 20px 0;
}

.text-content{
    font-size: 22px;
    color: #666565;
    line-height: 1.4;

    p{
        margin: 0;
    }
}


.notice{
    margin-top: 20px;
    font-size: 18px;
    color: #ee6044;
    text-align: center;
}

.info{
    font-size: 20px;
    text-align: center;
    margin-bottom: 18px;
}

.u-btn.copy{
    width: 286px;
    height:80px;
    margin: 35px auto 0;
    background-image: url(~@/assets/images/modal/btn-copy.png);
} 

</style>